import styled, { css } from 'styled-components';

interface ButtonProps {
  isPurple?: boolean;
}

export const Container = styled.div`
  background-color: ${({ theme }) => theme.white};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px 10px;
  width: 100%;
`;

export const Title = styled.p`
  color: #7e4f96;
  text-align: center;
  width: 100%;
  font-size: 32px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.purple};

  @media (max-width: 500px) {
    margin-top: 10px;
  }
`;

export const Message = styled.p`
  margin-top: 20px;
  text-align: center;
  width: 100%;
  color: ${({ theme }) => theme.black};
  font-size: 18px;
`;

export const ImgOwl = styled.img`
`;

export const ContainerButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Button = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #999;
  width: 100%;
  height: 100%;
    ${props => props.isPurple && css`
        background-color: #7e4f96;
    `}

    &:hover {
      filter: brightness(1.1);
    }
`;

export const TextButton = styled.p`  
  color:#fff;
  font-size: 25px;
  text-transform: uppercase;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 0;
  padding: 10px;
`;